import { FsNode, FsElement, FsRootDocument } from '@fullstory/playback-web';
import { FramePath, NodePath, HighlightElementByIds } from '@fullstory/renderer-shared';

/**
 * Starts at the fsNode element and then return it or its
 * first ancestor that has a width and height.
 *
 * Note: If one is not found within the first 150 ancestors then
 * we will return the original node. causing a 2px box to appear
 * at its location.
 */
export const firstVisibleFsNodeAncestor = (fsNode: FsNode): FsElement | null => {
  if (!fsNode.isElement()) {
    return null;
  }
  let node = fsNode;
  let boundingBox = node.dom.getBoundingClientRect();
  let size = boundingBox.height * boundingBox.width;

  for (let i = 0; size <= 0 && i <= 150; i++) {
    if (node.parent.isElement()) {
      node = node.parent;
      boundingBox = node.dom.getBoundingClientRect();
      size = boundingBox.height * boundingBox.width;
    }
  }

  return node;
};

/**
 * Takes in element's identifiers and then returns the selectors needed to
 * find them in the dom.
 */
export const getFsElementFromFsIds = (
  highlightElementByIds: HighlightElementByIds,
  fsDocumentRoot: FsRootDocument,
): FsElement | null => {
  // sanity check
  if (!fsDocumentRoot || !highlightElementByIds) {
    return null;
  }
  const { fId, fsId, pIds } = highlightElementByIds;
  try {
    const fsFramePath = new FramePath(fId, pIds);
    const fsNodePath = new NodePath(fsFramePath, fsId);
    // If the element that we are trying to highlight does not have a width & height
    // there if no point in highlighting it. We need to find it closest ancestor that
    // does have a width and height
    return firstVisibleFsNodeAncestor(fsDocumentRoot.getRelatedNode(fsNodePath));
  } catch (e) {
    console.error(
      'Error: Unable to find element related to selected event to highlight via Ids',
      e,
    );
  }

  return null;
};
